import React from 'react';
import classNames from 'classnames';
import MultipleAvatars from './MultipleAvatars';
import { Icon } from '@beisen/chaos-ui';
require('./ApprovalItem.scss');
/*

            "id": "d4800d99-6f81-4f4b-9904-f48747d3a405",
            "name": "第一审批人",
            "x": 0.0,
            "y": 0.0,
            "assignes": [
                {
                    "id": 107460817,
                    "name": "anxuenan",
                    "headPortrait": "",
                    "color": "#f79c6f"
                }
            ],
            "assignesNames": 'anxuenan,sss'
            "status": 2,
            "isStart": false,
            "isEnd": false,
            "url": null
        
*/
class ApprovalItem extends React.Component {

	constructor(props) {
		super(props);
        this.handleTapReadmore = this.handleTapReadmore.bind(this);
        this.state = {
            itemHeight: 48
            ,top: 32
        };
	}

    componentDidMount() {
        const preItemHeight = this.refs.approvalItem.previousSibling ? this.refs.approvalItem.previousSibling.offsetHeight : 0;
        const height = (preItemHeight + this.refs.approvalItem.offsetHeight) / 2 - 8;
        this.setState({ top: preItemHeight / 2, itemHeight: height });
    }

    handleTapReadmore(e) {
        e.preventDefault();
        this.props.tapReadmore && this.props.tapReadmore();
    }

    renderApprovalIcon(index) {
        const { itemInfo } = this.props;
        let iconName = '';
        switch(itemInfo.status) {
            case 1:
                iconName = (itemInfo.isStart && index == 0) ? 'm-sys-kaishi-yiwancheng' : itemInfo.isEnd ? 'm-sys-approval-end-true' : 'm-sys-approval-complate';
                break;
            case 2:
                iconName = 'm-sys-approval-progress';
                break;
            case 3:
                iconName = itemInfo.isEnd ? 'm-sys-approval-end-false' : 'm-sys-weikaishi';
                break;
            case 4:
                return <span className="approval-item-icon approval-item-readmore" />;
            case 5:
                iconName = 'm-sys-cancleprocess';
                break;
            default:
                iconName = 'm-sys-weikaishi';
        }
        return <Icon icon={iconName} className="approval-item-icon" />;
    }

    renderApprovalText() {
        const { completed,progress,unstart,viewAll,canceled } = this.props.translation;
        let text = '';
        switch(this.props.itemInfo.status) {
            case 1:
                text = completed;
                break;
            case 2:
                text = progress;
                break;
            case 3:
                text = unstart;
                break;
            case 4:
                text = viewAll;
                break;
            case 5:
                text = canceled;
                break;
            default:
                text = unstart;
        }
        return <span className={classNames('approval-item-text', 't-' + this.props.itemInfo.status)}>{text}</span>;
    }

    renderApprovalName() {
        const { itemInfo } = this.props;
        const hasAvatars = itemInfo.assignes && itemInfo.assignes.length > 0;
        return (<div className={classNames('approval-item-names', 'n-' + itemInfo.status,{ 'only': hasAvatars ? false : true })}>
                    <div className="approval-item-name">
                        {itemInfo.name}
                    </div>
                    {itemInfo.assignesNames ? <div className="approval-item-assignesNames">{itemInfo.assignesNames}</div> : null}
            </div>
        );
    }

	render() {
        const { itemInfo } = this.props;
        const hasAvatars = itemInfo.assignes && itemInfo.assignes.length > 0;
        return (
            <div className="approval-item-old" ref="approvalItem">
                <div className="approval-item-left">
                    {this.renderApprovalIcon(this.props.index)}
                    {this.props.index != 0 ? <div className={classNames('approval-item-line', 'l-' + itemInfo.status)} style={{ height: itemInfo.status == 4 ? (this.state.itemHeight + 2) : this.state.itemHeight + 'px', top: -this.state.top }} /> : null}
                </div>
                {itemInfo.status == 4 ? <div className="approval-item-right" onTouchTap={this.handleTapReadmore}> {this.renderApprovalText()}<Icon className='arrow' icon="m-sys-forward" /></div>
                 : <div className="approval-item-right">
                        {this.renderApprovalText()}
                        <span className="approval-item-separate" />
                        {hasAvatars ? <MultipleAvatars cls="approval-item-avatars" assignes={itemInfo.assignes} status={itemInfo.status} /> : null}
                        {this.renderApprovalName()}
                   </div>
                }
            </div>
        );
    }
}

export default ApprovalItem;


// WEBPACK FOOTER //
// ./src/components/Approval/old/ApprovalItem.js